import moment from 'moment';
import { useRouter } from 'next/router';
import React from 'react';
import { connect } from 'react-redux';

import ListPageStates from '@/src/shared/components/ListPage/ListPageStates';
import withMembershipAccessWrap, {
  mapStateToProps,
} from '@/src/shared/components/MembershipPageWrap';
import { COMPLIANCE_ACCESS } from '@/src/shared/constants';
import useListSearch from '@/src/shared/hooks/useListSearch';
import states from '@/utils/states';

const now = moment();
const nowMinu5Yrs = moment().add(-5, 'years');

const searchOptions = {
  pubCode: 381,
  dateStart: nowMinu5Yrs.format('MM/DD/YYYY'),
  dateEnd: now.format('MM/DD/YYYY'),
  date: 'true',
  sortField: 'state',
};

const StateFilingGuide = props => {
  const router = useRouter();
  const { statecode } = props;
  const _statecode = statecode || router.query.slug || 0;
  const [loading, results] = useListSearch(searchOptions, _statecode);

  return (
    <ListPageStates
      title="State Filing Guide"
      heroContent={null}
      results={results}
      truncateResultSummary
      searchOptions={searchOptions}
      statecode={_statecode}
      loading={loading}
      titlePrefix=""
      routeBase="/compliance/state-filings/state-filing-guide"
    />
  );
};

export async function getStaticPaths() {
  return {
    paths: states.map(s => ({ params: { slug: s.StateCode } })),
    fallback: false,
  };
}

export async function getStaticProps({ params }) {
  return {
    props: {
      statecode: params.slug || 0,
    },
  };
}

export default connect(mapStateToProps)(
  withMembershipAccessWrap(StateFilingGuide, COMPLIANCE_ACCESS.STATE_FILINGS)
);
